import { render } from "./editTeam.vue?vue&type=template&id=f62be1e2&scoped=true"
import script from "./editTeam.vue?vue&type=script&lang=js"
export * from "./editTeam.vue?vue&type=script&lang=js"

import "./editTeam.vue?vue&type=style&index=0&id=f62be1e2&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f62be1e2"]])

export default __exports__